// frontend/src/samkalp-admin/panels/AuditPanel.js
import React, { useState, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import TenantAuditLogTable from '../../components/TenantAdmin/TenantAuditLogTable';
import { getTenantAuditLogs } from '../../api/api';

const AuditPanel = ({ slug }) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getTenantAuditLogs(slug)
            .then(res => setLogs(res.data || []))
            .catch(() => setLogs([]))
            .finally(() => setLoading(false));
    }, [slug]);

    if (loading) return <div className="text-center py-5"><Spinner animation="border" /></div>;
    return <TenantAuditLogTable logs={logs} />;
};

export default AuditPanel;
